export default __webpack_public_path__ + "static/media/Logo.82be6af3.svg";